import { Brand } from './brand.model';
import { Category } from './category.model';
import { PhotographerBase } from './photographer-base.model';

export class Photographer extends PhotographerBase {
  public active?: boolean;
  public statusId?: number;
  public statusName?: string;
  public statusColor?: string;
  public companyId?: number;
  public companyName?: string;
  public shotCost?: number;
  public maxItems?: number;
  public totalPaid?: number;
  public monthlyPaid?: number;
  public discountThreshold?: number;
  public discountPercentage?: number;
  public brands?: Array<PhotographerBrand>;
  public automaticRenewal?: boolean;
  public hiredFrom?: string;
  public hiredUntil?: string;
  public imgPath?: string;
  public onTrial?: boolean;

  public isVisible?: boolean;
  public checked?: boolean;

  constructor(init?: Partial<Photographer>) {
    super();
    Object.assign(this, init);
  }
}

export class PhotographerBrand extends Brand {
  public personId: number;
  public categories: Array<PhotographerCategory>;

  constructor(init?: Partial<PhotographerBrand>) {
    super();
    Object.assign(this, init);
  }
}

export class PhotographerCategory {
  public personId: number;
  public brandId: number;
  public categoryId: number;
  public categoryName: string;

  constructor(init?: Partial<PhotographerCategory>) {
    Object.assign(this, init);
  }
}
